{
  "cashier": "Касса",
  "depositTab": "Депозит",
  "withdrawTab": "Вывод",
  "historyTab": "История",
  "secureNote": "Безопасно и зашифровано",
  "selectMethod": "Выберите способ оплаты",
  "amount": "Сумма",
  "amountPlaceholder": "Введите сумму",
  "quickAmounts": "Быстрые суммы",
  "continue": "Продолжить",
  "depositNow": "Внести депозит",
  "withdrawNow": "Запросить вывод",
  "methodDisabled": "Этот способ ещё не активен",
  "methodsPending": "Платёжные реквизиты ещё не настроены администратором",
  "receiptRequired": "Требуется загрузка чека — чек не является подтверждением оплаты",
  "adminVerification": "Баланс увеличивается только после независимой проверки админом",
  "noCryptoNetworks": "Криптосети не настроены",
  "noAddress": "Адрес депозита ещё не назначен",
  "cardToCard": "Карта на карту",
  "cardToCardDesc": "Перевод на банковскую карту",
  "m10": "M10",
  "m10Desc": "Перевод M10",
  "terminal": "Терминал",
  "terminalDesc": "Оплата через терминал",
  "crypto": "Kriptovalyuta",
  "cryptoDesc": "Крипто-депозит",
  "bankCardWithdraw": "Банковская карта",
  "m10Withdraw": "M10",
  "cryptoWithdraw": "Крипто",
  "minMax": "Мин {{min}} — Макс {{max}}",
  "trustInstant": "Быстрая обработка при настройке",
  "trustSecure": "Безопасные операции",
  "trustMethods": "Карта на карту, M10, Терминал, Крипто",
  "historyEmpty": "Нет транзакций",
  "historyAuth": "Войдите, чтобы увидеть историю",
  "balanceTitle": "Баланс",
  "openCashier": "Касса",
  "topUp": "Пополнить",
  "bonusAccount": "Бонусный счёт",
  "reservedFunds": "Зарезервировано",
  "copyId": "Скопировать ID",
  "loginRequired": "Войдите, чтобы продолжить",
  "region": "Регион оплаты",
  "instructionsSoon": "Инструкции появятся после назначения реквизита",
  "uploadReceipt": "Загрузить чек",
  "uploadDisabled": "Чек не принимается до создания заявки на депозит",
  "depositCreated": "Заявка на депозит создана",
  "receiptUploaded": "✅ Чек загружен. Заявка на оплату записана. Пожалуйста, подождите.",
  "withdrawReserved": "Вывод зарезервирован",
  "destination": "Реквизиты получателя",
  "destinationRequired": "Укажите реквизиты получателя",
  "noCvv": "CVV и PIN не требуются и не принимаются",
  "status": "Статус",
  "copy": "Копировать",
  "bankPayment": "Банковский платёж",
  "currentBalance": "Текущий баланс: {{amount}}",
  "copied": "Скопировано",
  "selectCoin": "Монета",
  "selectNetwork": "Сеть",
  "timeRemaining": "Осталось",
  "depositExpired": "Срок заявки истёк. Создайте новую.",
  "cancelDeposit": "Отменить заявку",
  "qrLabel": "QR адреса депозита",
  "copyAddress": "Адрес",
  "cardHolder": "Держатель карты (необязательно)",
  "sendExactAmount": "Отправьте точную сумму. Неверная сеть или сумма не будут зачислены.",
  "noPairsConfigured": "Пара монета/сеть ещё не настроена",
  "depositCancelled": "Заявка на депозит отменена",
  "usdRate": "1 USD = {{rate}} AZN",
  "minUsd": "Мин. ${{usd}}",
  "saveQr": "Сохранить QR",
  "networkWarning": "Отправляйте только в сети {{network}}. Неверная сеть может привести к безвозвратной потере средств.",
  "filter_all": "Все",
  "filter_deposit": "Депозит",
  "filter_withdrawal": "Вывод",
  "field_card_number": "Номер карты",
  "field_card_holder": "Держатель карты",
  "field_bank_name": "Банк",
  "field_m10_account": "Счёт M10",
  "field_account_holder": "Владелец счёта",
  "field_terminal_code": "Код терминала",
  "field_address": "Адрес",
  "field_asset": "Монета",
  "field_network": "Сеть",
  "field_memo": "Memo",
  "field_phone": "Телефон",
  "field_iban": "IBAN",
  "field_name": "Имя",
  "methodSelected_card_to_card": "Выбран перевод с карты на карту",
  "methodSelected_m10": "Выбран платёж M10",
  "methodSelected_terminal": "Выбран платёж через терминал",
  "methodSelected_crypto": "Выбрана криптовалюта",
  "cryptoUnavailable": "Криптовалютный депозит ещё не готов",
  "cryptoUnavailableHint": "Принимающий адрес и сеть не настроены администратором. Не отправляйте средства — фальшивый кошелёк не показывается.",
  "quotePreview": "Котировка",
  "expectedCredit": "Ожидаемый кредит в AZN",
  "estimatedCrypto": "Ориентировочная сумма в криптовалюте",
  "adminRateNote": "Этот курс задан администратором, это не рыночная цена.",
  "enterAmountFirst": "Сначала введите сумму, затем выберите монету и сеть.",
  "status_waiting_for_payment": "Ожидание оплаты",
  "status_detected": "Перевод обнаружен",
  "status_awaiting_confirmations": "Ожидание подтверждений",
  "status_pending_review": "На проверке",
  "status_confirmed": "Подтверждено",
  "status_expired": "Истекло",
  "status_ambiguous": "Нужна ручная проверка",
  "status_error": "Ошибка / не поддерживается",
  "status_cancelled": "Отменено",
  "status_rejected": "Отклонено",
  "status_approved": "Подтверждено",
  "expiredLateNote": "Поздний перевод по блокчейну всё ещё может прийти после истечения. Он не зачисляется автоматически и требует проверяемой сверки.",
  "enlargeQr": "Увеличить QR",
  "closeQr": "Закрыть",
  "confirmationTimeNote": "10-минутный таймер — это окно ожидания заявки, а не время подтверждения в сети.",
  "usdEquivalent": "Эквивалент USD: ${{usd}}",
  "quoteUnavailable": "Котировка недоступна. Проверьте сумму и сеть.",
  "depositRequests": "Заявки на депозит",
  "networkMismatch": "Отправляйте только в указанную сеть.",
  "safeRecovery": "Связь прервалась. Последняя сохранённая заявка будет восстановлена.",
  "historyAll": "Все",
  "historyDeposit": "Депозит",
  "historyWithdrawal": "Вывод",
  "historyEmptyTitle": "История операций пуста",
  "historyEmptyDescription": "Здесь будут показаны ваши депозиты и выводы.",
  "historyBankDeposit": "Банковский депозит",
  "statusPending": "Ожидание",
  "statusReview": "На проверке",
  "statusApproved": "Подтверждено",
  "statusPaid": "Оплачено",
  "statusCompleted": "Завершено",
  "statusRejected": "Отклонено",
  "statusExpired": "Срок истёк",
  "statusCancelled": "Отменено",
  "statusFailed": "Ошибка",
  "withdrawAcceptedClean": "Заявка на вывод принята и отправлена на проверку.",
  "selectBankLocal": "Выберите банк",
  "holderFullNameLocal": "Имя и фамилия владельца карты",
  "recipientCardLocal": "Номер карты получателя",
  "availableBalanceLocal": "Доступный баланс",
  "backWithdrawalLocal": "Назад — способы вывода",
  "withdrawDetailsLocal": "Введите данные для вывода",
  "paymentMethodsLocal": "Способы оплаты",
  "paymentAmountLocal": "Сумма платежа",
  "transactionTypeLocal": "Тип операции",
  "walletSectionsLocal": "Разделы кошелька",
  "cryptoTransferTitle": "Криптовалютный депозит",
  "cryptoTransferAmount": "Сумма перевода",
  "cryptoOrderAmount": "Сумма заявки",
  "cryptoTransferAddress": "Адрес кошелька",
  "cryptoTransferNetwork": "Сеть",
  "cryptoShowQr": "Показать QR-код",
  "cryptoQrWaiting": "QR-код недоступен",
  "cryptoNoAddress": "Адрес недоступен. Не переводите средства.",
  "cryptoWarnNetwork": "Отправляйте только {{asset}} через сеть {{network}}. Перевод через другую сеть может привести к потере средств.",
  "cryptoWarnAmount": "Проверьте сумму и комиссию сети. Недостаточный перевод может быть не зачислен.",
  "cryptoMoreInfo": "Дополнительные сведения",
  "cryptoMemo": "Memo / Tag",
  "prevStep": "Предыдущий шаг",
  "depositAmount": "Сумма депозита",
  "paymentInstruction": "Инструкция по оплате",
  "paymentConfirm": "Подтверждение оплаты",
  "depositStages": "Этапы депозита",
  "stageAmount": "Сумма",
  "stagePayment": "Оплата",
  "stageReceipt": "Чек",
  "receiptSend": "Отправка чека",
  "rejected": "Отклонено",
  "network": "Сеть",
  "paymentNote": "Примечание к платежу",
  "extraPaymentInfo": "Дополнительные платёжные данные",
  "invalidAmount": "Введите корректную сумму.",
  "tapToSelect": "Нажмите, чтобы выбрать",
  "walletLabel": "Кошелёк",
  "previewBanner": "ТЕСТОВЫЙ РЕЖИМ: Все карты оплаты выбираются. Не отправляйте реальные деньги; депозит и вывод не выполняются.",
  "otherBank": "Другой банк",
  "cryptoAsset": "Криптовалюта",
  "receiveAddress": "Адрес получения",
  "notAssigned": "Не назначено",
  "paymentMethod": "Способ оплаты",
  "bank": "Банк",
  "recipient": "Получатель",
  "cardNumber": "Номер карты",
  "qrWhenReady": "QR появится только при наличии реального адреса",
  "qrInactive": "QR неактивен",
  "qrInactiveHint": "Появится здесь после назначения адреса.",
  "networkAttention": "Внимание: сеть {{network}}",
  "networkAttentionBody": "Переводите только на адрес выбранной сети. Неверная сеть или сумма могут привести к потере средств.",
  "minDepositFees": "Минимальный депозит и комиссия",
  "minDepositFeesBody": "Проверьте минимум и комиссию сети до отправки. Не переводите без адреса.",
  "waitingTransfer": "Ожидаем перевод",
  "waitingTransferBody": "Оплачивайте только подтверждённые реквизиты на точную сумму.",
  "wrongTransfer": "О неверных переводах",
  "wrongTransferBody": "Платёж в другой банк, на другую карту или сумму может не зачислиться.",
  "previewNoAddress": "ТЕСТ · АДРЕС НЕ ВЫДАН · НЕ ОТПРАВЛЯЙТЕ ДЕНЬГИ",
  "addReceiptTitle": "Прикрепите чек",
  "addReceiptBody": "Сфотографируйте, выберите из галереи или приложите файл. В тесте файл на сервер не отправляется.",
  "cameraCapture": "Снять на камеру",
  "sampleTimer": "Пример таймера — реальная заявка не создана",
  "transferDetails": "Данные перевода",
  "paymentDetailsStep": "Платёжные данные",
  "paymentConfirmStep": "Подтверждение оплаты",
  "iPaidReceipt": "Я оплатил · Экран чека",
  "fromGallery": "Выбрать из галереи",
  "chooseFile": "Выбрать файл",
  "cameraFileSelected": "Файл камеры выбран: {{name}}. В тесте на сервер не загружается.",
  "imageSelected": "Изображение выбрано: {{name}}. В тесте на сервер не загружается.",
  "fileSelected": "Файл выбран: {{name}}. В тесте на сервер не загружается.",
  "previewTest": "Тест",
  "fileNotUploaded": "Файл не загружается на сервер",
  "bankSelect": "Выбор банка",
  "depositBonusSample": "Бонус депозита · пример",
  "checkFinalAmount": "Проверьте итоговую сумму в созданном заказе.",
  "orderNumber": "Номер заказа:",
  "amountDue": "К оплате:",
  "requestProcessing": "Заявка обрабатывается",
  "paymentCreated": "Заявка на оплату успешно создана!",
  "completeTransferHint": "Завершите перевод по платёжным данным ниже.",
  "exactAmountWarn": "Внимание! Отправляйте только указанную сумму по правильным реквизитам.",
  "uploadReceiptAfter": "После перевода загрузите чек.",
  "paymentInfo": "Платёжные данные",
  "cardHolderName": "Имя владельца карты",
  "receiverName": "Имя получателя",
  "accountNumber": "Номер счёта",
  "previewDepositSelected": "ТЕСТ: {{method}} — {{amount}} AZN выбран. Реальный депозит не создан; деньги не отправляйте.",
  "previewWithdrawChecked": "ТЕСТ: вывод {{amount}} AZN по {{method}} проверен. Реальная заявка не создана.",
  "checkingFileSelection": "Проверяем выбранный файл",
  "bonusSampleLine": "5%: {{bonus}} · итог: {{total}}",
  "phoneNumber": "Номер телефона",
  "addressLabel": "адрес",
  "uploadReceiptReminder": "После оплаты не забудьте загрузить чек.",
  "previewWithdrawBanner": "ТЕСТ: Реальный вывод не отправляется и баланс не меняется.",
  "cardExpiry": "Срок карты (ММ/ГГ)",
  "checkRequest": "Проверить заявку",
  "bonusNotOnReal": "На реальный баланс не начисляется.",
  "realBalance": "Реальный баланс",
  "gameCurrencies": "Игровые валюты",
  "walletCta": "Кошелёк",
  "closeGameFirst": "В активной игре есть незакрытая ставка. Закройте игру, затем смените валюту.",
  "regionLabel": "Платёжный регион",
  "regionCryptoOnly": "В этом регионе доступны только криптоплатежи",
  "tonConnectTitle": "Депозит через TON Connect",
  "tonConnectWallet": "Подключить TON-кошелёк",
  "tonPayConfirm": "Подтвердите оплату в кошельке",
  "tonDisconnectWallet": "Отключить кошелёк",
  "tonWalletStatus": "Статус кошелька",
  "tonWalletNotConnected": "Не подключён",
  "tonWalletConnected": "Подключён · {{address}}",
  "tonWalletConnectedHint": "Ваш TON-кошелёк успешно привязан.",
  "tonWalletDisconnected": "Кошелёк отключён.",
  "tonWalletConnectFailed": "Не удалось подключить кошелёк.",
  "tonConnectWalletFirst": "Сначала подключите TON-кошелёк.",
  "tonConfirmInWallet": "Подтвердите оплату в кошельке.",
  "tonPendingAdminReview": "Заявка на депозит создана. Оплата ожидает проверки администратором.",
  "tonDepositCreated": "Заявка на TON-депозит создана. Завершите оплату в кошельке.",
  "tonPaymentCancelled": "Оплата отменена или не завершена.",
  "tonPaymentMissing": "Нет данных об оплате. Попробуйте снова.",
  "tonPaymentProofMissing": "Кошелёк не вернул подтверждение оплаты. Если оплата не прошла, попробуйте снова.",
  "tonWarnNativeOnly": "Отправляйте только native TON. Другие токены или сети могут привести к потере средств.",
  "tonWarnAdminReview": "Подтверждение в кошельке не означает зачисление. Баланс увеличится после проверки администратором.",
  "gameCurrency": "Игровая валюта"
}
